import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LMLabelDirective } from './lm-label.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LMLabelDirective
  ],
  exports: [
    LMLabelDirective
  ]
})
export class LMLabelModule {}
